export default __webpack_public_path__ + "static/media/thrivepass-glyph.887c2a29.png";